"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EventEmitter {
    constructor() {
        this._eventListeners = {};
        this._firedEvents = [];
    }
    emit(type, payload) {
        const event = this.createEvent(type, payload);
        this._firedEvents[type] = event;
        if (!(event.type in this._eventListeners)) {
            return false;
        }
        const subscribers = this._eventListeners[event.type].slice();
        for (let i = 0, l = subscribers.length; i < l; i++) {
            const subscriber = subscribers[i];
            subscriber.fired = true;
            subscriber.callback.call(this, event);
        }
        return true;
    }
    on(type, callback, config = { immediate: false }) {
        if (!(type in this._eventListeners)) {
            this._eventListeners[type] = [];
        }
        this._eventListeners[type].push({
            callback,
            immediate: config.immediate,
        });
        const event = this.createEvent(type);
        if (this._firedEvents[type]) {
            callback(this._firedEvents[type]);
            return;
        }
        this._eventListeners[type]
            .slice()
            .filter(subscriber => subscriber.fired && subscriber.immediate)
            .forEach((subscriber) => subscriber.callback(event));
    }
    createEvent(type, payload) {
        return {
            type,
            target: this,
            payload,
        };
    }
}
exports.default = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map